import React from "react";
import { StyledDivider } from "./Divider.styles";
import { DividerProps } from "./Divider.types";

export const Divider = (props: DividerProps) => {
  const { width, variant = "Line" } = props;

  return <StyledDivider width={width} variant={variant}></StyledDivider>;
};
